module.exports = __webpack_public_path__ + "img/blog-02.cdf44eda.jpg";